module.exports = __webpack_public_path__ + "img/5.c8962aa2.jpg";